/**
 * Pearla 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

/**
 * Pearla 品牌特定主题配置
 */
export const theme = {
  popupTagBgColor: '#EFF3FA',
  popupTagColor: '#65686F',
  popupTagActiveColor: '#FFFFFF',

  filterBgColor: '#EFF3FA',
  filterActiveBgColor: '#F5F0FF',
  filterColor: '#65686F',
  filterActiveColor: '#AB75FB',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
